import api from './api';
import { ITEM_DOACAO, ENTIDADE, OFICIO, UPLOAD_ROUTE } from '../constants/apiRoutes';

export default {
	findBySearch(filter) {
		if (!filter.pagina) {
			filter.pagina = 0;
		}

		return api.post(ITEM_DOACAO.FIND_FILTRO, filter);
	},

	findByIdAndTransacoes(id, filter) {
		return api.post(ITEM_DOACAO.FIND_ID_FILTRO.replace('{id}', id), filter);
	},

	findAll(filter) {
		return api.post(ITEM_DOACAO.FIND_FILTRO, filter);
	},

	cadastraDoacao(values) {
		return api.post(ITEM_DOACAO.SALVAR, values);
	},

	findAllTipoItemDoacao() {
		return api.get(ITEM_DOACAO.FIND_ALL_ITEM_DOACAO);
	},

	findAllUnidadeMedida() {
		return api.get(ITEM_DOACAO.FIND_ALL_UNIDADE_MEDIDA);
	},

	salvarEntradaDoacao(values) {
		return api.post(ITEM_DOACAO.ENTRADA, values);
	},

	salvarSaidaDoacao(values) {
		return api.post(ITEM_DOACAO.SAIDA, values);
	},

	/* ENTIDADES */
	findAllEntidadesSemPaginacao() {
		return api.get(ENTIDADE.FIND_ALL_FILTRO);
	},

	findAllEntidades(filter) {
		return api.post(ENTIDADE.FIND_FILTRO, filter);
	},

	salvarEntidade(values) {
		return api.post(ENTIDADE.SALVAR, values);
	},

	findEntidadeById(id) {
		return api.get(ENTIDADE.FIND_ID_FILTRO.replace('{id}', id));
	},

	cancelarEntidade(entidade) {
		return api.post(ENTIDADE.CANCELAR, entidade);
	},

	findOficiosByEntidade(entidade) {
		return api.get(ENTIDADE.FIND_ALL_OFICIOS.replace('{id}', entidade.id));
	},

	/* OFICIOS */
	findAllOficios(filter) {
		return api.post(OFICIO.FIND_ALL_FILTRO, filter);
	},

	salvarOficio(values) {
		return api.post(OFICIO.SALVAR, values);
	},

	findOficiosSemPaginacao() {
		return api.get(OFICIO.FIND_ALL);
	},

	findOficiosAtivosSemPaginacao() {
		return api.get(OFICIO.ATIVOS);
	},

	uploadDocumento(documento) {
		const dataForm = new FormData();
		dataForm.append('arquivo', documento[0].file);

		return api.post(UPLOAD_ROUTE.UPLOAD_ARQUIVO, dataForm);
	},

	findOficioById(id) {
		return api.get(OFICIO.FIND_ID.replace('{id}', id));
	},

	editarOficio(oficio) {
		return api.post(OFICIO.EDITAR, oficio);
	},

	cancelarOficio(oficio) {
		return api.post(OFICIO.CANCELAR, oficio);
	},

	/* STATUS OFICIO */

	findAllStatusOficio() {
		return api.get(OFICIO.FIND_ALL_STATUS);
	},

	/* TRANSAÇÔES */
	editarTransacao(transacao) {
		return api.post(ITEM_DOACAO.HISTORICO_EDITAR, transacao);
	},

	findHistoricoById(id) {
		return api.get(ITEM_DOACAO.FIND_ALL_HISTORICO.replace('{id}', id));
	},

	cancelarTransacao(transacao) {
		return api.post(ITEM_DOACAO.HISTORICO_CANCELAR, transacao);
	},
};
